import "./Register.css";

import { GoogleReCaptchaProvider, useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { useEffect, useState } from "react";

import CustomInput from "../../components/CustomInput/CustomInput";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import PasswordValidator from "../../components/PasswordValidator/PasswordValidator";
import ReactLoading from "react-loading";
import appConfig from "../../config";
import { register } from "../../api/auth";
import { setLoginVisible } from "../../store/modals/modalActions";
import { useNavigate } from "react-router-dom";

const Register = () => {
  const dispatch = useAppDispatch();
  const [fullname, setFullName] = useState<string>();
  const [email, setEmail] = useState<string>();
  const [mobile, setMobile] = useState<string>();
  const [idType, setIDType] = useState<string>("1");
  const [idNumber, setIDNumber] = useState<string>();
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [termsAccepted, setTermsAccepted] = useState<boolean>();
  const [errors, setErrors] = useState<string[]>([]);
  const user = useAppSelector((state) => state.auth.user);
  const [loading, setLoading] = useState<boolean>(false);

  const [registered, setRegistered] = useState<boolean>(false);
  const infringement = useAppSelector((state) => state.fine.infringement);
  const navigate = useNavigate();
  const { executeRecaptcha } = useGoogleReCaptcha();

  useEffect(() => {
    dispatch(setLoginVisible(false));
    if (user) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (infringement && user && user.is_verified) navigate("/fine");
  }, [infringement, user]);

  const onRegisterClicked = () => handleRegistration();

  const validateID = () => {
    var idPattern =
      /^(((\d{2}((0[13578]|1[02])(0[1-9]|[12]\d|3[01])|(0[13456789]|1[012])(0[1-9]|[12]\d|30)|02(0[1-9]|1\d|2[0-8])))|([02468][048]|[13579][26])0229))(( |-)(\d{4})( |-)(\d{3})|(\d{7}))/;
    return idNumber && idPattern.test(idNumber.replace(/ /g, ""));
  };

  const validateEmail = () => {
    setErrors([]);
    if (!email?.trim()) {
      document.getElementById("email-input")!.style.border = "1px solid red";
      setErrors((errors) => [...errors, "Please enter an email"]);
      return false;
    } else {
      document.getElementById("email-input")!.style.border = "1px solid #d7d7d7";
    }
    if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      document.getElementById("email-input")!.style.border = "1px solid red";
      setErrors((errors) => [...errors, "Please enter a valid email"]);
      return false;
    } else {
      document.getElementById("email-input")!.style.border = "1px solid #d7d7d7";
    }
    return true;
  };

  const validate = () => {
    setErrors([]);
    if (fullname && /\d/.test(fullname)) {
      setErrors((errors) => [...errors, "Full name cannot contain numbers"]);
      return false;
    }
    if (!fullname?.trim()) {
      document.getElementById("name-input")!.style.border = "1px solid red";
      setErrors((errors) => [...errors, "Please enter a full name"]);
      return false;
    } else {
      document.getElementById("name-input")!.style.border = "1px solid #d7d7d7";
    }
    if (!validateEmail()) {
      return false;
    }
    if (!mobile?.trim()) {
      document.getElementById("mobile-input")!.style.border = "1px solid red";
      setErrors((errors) => [...errors, "Please enter a mobile number"]);
      return false;
    } else {
      document.getElementById("mobile-input")!.style.border = "1px solid #d7d7d7";
    }

    if (mobile && !/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g.test(mobile.replace(/ /g, ""))) {
      document.getElementById("mobile-input")!.style.border = "1px solid red";
      setErrors((errors) => [...errors, "Please enter a valid mobile number"]);
      return false;
    } else {
      document.getElementById("mobile-input")!.style.border = "1px solid #d7d7d7";
    }

    if (!idType?.trim()) {
      document.getElementById("id-type-input")!.style.border = "1px solid red";
      setErrors((errors) => [...errors, "Please select an ID type"]);
      return false;
    } else {
      document.getElementById("id-type-input")!.style.border = "1px solid #d7d7d7";
    }

    if (idType === "1" && !validateID()) {
      document.getElementById("id-input")!.style.border = "1px solid red";
      setErrors((errors) => [...errors, "Please enter a valid ID number"]);
      return false;
    } else {
      document.getElementById("id-input")!.style.border = "1px solid #d7d7d7";
    }
    if (idType === "2" && !idNumber) {
      document.getElementById("id-input")!.style.border = "1px solid red";
      setErrors((errors) => [...errors, "Please enter a passport number"]);
      return false;
    } else {
      document.getElementById("id-input")!.style.border = "1px solid #d7d7d7";
    }
    if (idType === "2" && !/^[a-zA-Z0-9_]*$/.test(idNumber!)) {
      document.getElementById("id-input")!.style.border = "1px solid red";
      setErrors((errors) => [...errors, "Please enter a valid passport number"]);
      return false;
    } else {
      document.getElementById("id-input")!.style.border = "1px solid #d7d7d7";
    }

    if (!password?.trim()) {
      document.getElementById("password-input")!.style.border = "1px solid red";
      setErrors((errors) => [...errors, "Please enter a password"]);
      return false;
    } else {
      document.getElementById("password-input")!.style.border = "1px solid #d7d7d7";
    }

    if (!confirmPassword?.trim()) {
      document.getElementById("confirm-password-input")!.style.border = "1px solid red";
      setErrors((errors) => [...errors, "Please confirm your password"]);
      return false;
    } else {
      document.getElementById("confirm-password-input")!.style.border = "1px solid #d7d7d7";
    }

    if (password?.trim() !== confirmPassword?.trim()) {
      setErrors((errors) => [...errors, "Passwords must match"]);
      return false;
    }

    if (password && password?.trim().length < 8) {
      setErrors((errors) => [...errors, "Password must be 8 characters or more"]);
      return false;
    }

    if (!/[A-Z]/.test(password!)) {
      setErrors((errors) => [...errors, "Password must contain at least one uppercase character"]);
      return false;
    }

    if (!/[a-z]/.test(password!)) {
      setErrors((errors) => [...errors, "Password must contain at least one lowercase character"]);
      return false;
    }

    if (!/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password!)) {
      setErrors((errors) => [...errors, "Password must include at least one special character"]);
      return false;
    }
    if (!/\d/.test(password!)) {
      setErrors((errors) => [...errors, "Password must include at least one number"]);
      return false;
    }
    if (!termsAccepted) {
      document.getElementById("terms-checkbox")!.style.border = "1px solid red";
      setErrors((errors) => [...errors, "Please accept the terms of service and privacy policy"]);
      return false;
    } else {
      document.getElementById("terms-checkbox")!.style.border = "1px solid #d7d7d7";
    }
    return true;
  };

  const handleRegistration = async () => {
    if (!executeRecaptcha) {
      setLoading(false);
      return;
    }

    const token = await executeRecaptcha("register");
    if (validate() && token) {
      let registerResponse = await register(
        fullname!,
        email!.trim(),
        password!.trim(),
        mobile!.trim(),
        idType!,
        idNumber!.trim(),
        termsAccepted!,
        confirmPassword!.trim()
      );
      const { registerError } = registerResponse;
      if (!registerError) {
        setRegistered(true);
      } else {
        handleRegistrationError(registerError);
      }
    } else {
      setLoading(false);
    }
  };

  const handleRegistrationError = (error: any) => {
    console.log(error);
    Object.keys(error)?.map((e: any) => {
      setErrors((errors) => [...errors, error[e][0]]);
    });
    setLoading(false);
  };

  return (
    <GoogleReCaptchaProvider reCaptchaKey={appConfig.recaptchaSiteKey}>
      <div className="register-container">
        <Header />
        <div className="register-header">
          <p>Register</p>
          <p>Please note registration is currently only required for fines with a warrant status</p>
        </div>
        <div className="register-form">
          {!registered ? (
            <>
              <CustomInput
                label="FULL NAME & SURNAME*"
                id="name-input"
                placeholder="Name and Surname"
                value={fullname}
                setValue={setFullName}
                autoComplete="off"
                containerStyle={{ width: "100%" }}
              />

              <CustomInput
                label=" EMAIL ADDRESS*"
                id="email-input"
                placeholder="Email Address"
                value={email}
                setValue={setEmail}
                autoComplete="off"
                type="email"
                containerStyle={{ width: "100%" }}
                autoCapitalize="off"
                onBlur={validateEmail}
              />

              <CustomInput
                label="MOBILE NUMBER*"
                type="tel"
                id="mobile-input"
                placeholder="e.g 0810000000"
                value={mobile}
                setValue={setMobile}
                maxLength={10}
                pattern="[0-9]{10}"
                autoComplete="off"
                containerStyle={{ width: "100%" }}
              />

              <div className="register-id-container">
                <label id="id-type-label">
                  DOCUMENT TYPE
                  <select id="id-type-input" onChange={(e) => setIDType(e.target.value)}>
                    <option value="1">South African ID</option>
                    <option value="2">Passport</option>
                  </select>
                </label>
                <CustomInput
                  label={idType === "1" ? "ID NUMBER*" : "PASSPORT NUMBER*"}
                  id="id-input"
                  placeholder={idType === "1" ? "ID Number" : "Passport Number"}
                  value={idNumber}
                  type={idType === "1" ? "ID" : "text"}
                  setValue={setIDNumber}
                  autoComplete="off"
                />
              </div>
              <CustomInput
                label="CREATE A PASSWORD*"
                id="password-input"
                autoComplete="off"
                placeholder="Password"
                type="password"
                value={password}
                setValue={setPassword}
                containerStyle={{ width: "100%" }}
              />
              <CustomInput
                label="CONFIRM PASSWORD*"
                id="confirm-password-input"
                autoComplete="off"
                type="password"
                placeholder="Confirm Password"
                value={confirmPassword}
                setValue={setConfirmPassword}
                containerStyle={{ width: "100%" }}
              />

              <PasswordValidator password={password} newPassword={confirmPassword} />
              <div className="accept-terms">
                <input
                  id="terms-checkbox"
                  type="checkbox"
                  className="accept-checkbox"
                  onChange={(e) => setTermsAccepted(e.target.checked)}
                />
                <span>
                  I accept that Pay@ may use my information provided to send me important updates
                  and I also accept the{" "}
                  <a
                    target="_blank"
                    href="https://payat.io/qr/assets/files/210204%20-%20Processing%20Policy.pdf"
                  >
                    Pay@ Processing Policy
                  </a>
                </span>
              </div>

              {errors.length > 0 && (
                <div className="register-error-container" style={{ marginLeft: "3%" }}>
                  <p className="error-text">* {errors[0]}</p>
                </div>
              )}

              <p className="recaptcha-text">
                This site is protected by reCAPTCHA and the Google{" "}
                <a target="_blank" href="https://policies.google.com/privacy">
                  Privacy Policy
                </a>{" "}
                and{" "}
                <a target="_blank" href="https://policies.google.com/terms">
                  Terms of Service
                </a>{" "}
                apply.
              </p>
              <div className="register-button" onClick={() => onRegisterClicked()}>
                {!loading ? (
                  "Register Account"
                ) : (
                  <div className="register-loading">
                    <ReactLoading type="bubbles" color="white" />
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              <p className="registered-heading">THANK YOU FOR REGISTERING WITH PAY@</p>
              <p className="registered-subheading">
                YOU WILL RECEIVE AN EMAIL SOON WITH A LINK TO VERIFY YOUR ACCOUNT
              </p>
            </>
          )}
        </div>
        <Footer />
      </div>
    </GoogleReCaptchaProvider>
  );
};

export default Register;
